export { default as ClipboardListOutlineIcon } from './ClipboardListOutlineIcon';
